import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['SearchBox', 'SearchBoxDialogButton'].includes(w.name)),
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      type: 'SearchBox',
      template: 'SearchBox',
      onSubmit: () => window.document.querySelector('#search-drawer')?.removeAttribute('open'),
    },
  ],
};
